module.exports = __webpack_public_path__ + "files/fba6362db1d8b3e27c9fb02fd0695c85.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-144x144.png
// module id = 1205
// module chunks = 60